export const configProd = {
  baseUrl: "https://api.vodafone.billing.affinity.io/live-v1",
};
